import { store } from '~/store';
import { appsSlice } from '~/store/reducers/previewScreens/apps';
import { imagesSlice } from '~/store/reducers/previewScreens/images';
import { listOfLinksSlice } from '~/store/reducers/previewScreens/list-of-links';
import { pdfSlice } from '~/store/reducers/previewScreens/pdf';
import { socialMediaSlice } from '~/store/reducers/previewScreens/social-media';
import { vCardPlusSlice } from '~/store/reducers/previewScreens/vcard-plus';
import { websiteSlice } from '~/store/reducers/previewScreens/website';
import { qrCodeSlice } from '~/store/reducers/qr-code';

export const resetAllMicrositesReducersToInitialState = (dispatch) => {
  dispatch(pdfSlice.actions.resetState());
  dispatch(appsSlice.actions.resetState());
  dispatch(imagesSlice.actions.resetState());
  dispatch(websiteSlice.actions.resetState());
  dispatch(vCardPlusSlice.actions.resetState());
  dispatch(listOfLinksSlice.actions.resetState());
  dispatch(socialMediaSlice.actions.resetState());
};

export const resetFullQrState = () => {
  store.dispatch(qrCodeSlice.actions.resetState());
  resetAllMicrositesReducersToInitialState(store.dispatch);
};
